// getListNotificationSaga
import { callApiServiceCommon } from './service-common';

const commonApi = process.env.REACT_APP_API_COMMON_SERVICE_V2;

export function* updateNotificationService(shop, id) {
  const payload = {
    method: 'POST',
    url: `${commonApi}ak/update-notification`,
    params: {
      app_code: process.env.REACT_APP_CODE,
      shop_domain: shop,
      notification_id: id,
      read_status: true
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getListNotificationService(shop) {
  const payload = {
    method: 'GET',
    params: {
      app_code: process.env.REACT_APP_CODE,
      shop_domain: shop
    },
    url: `${commonApi}ak/get-notification`
  };
  return yield callApiServiceCommon(payload);
}

export function* getNotificationDetailService(shop, id) {
  const payload = {
    method: 'GET',
    params: {
      app_code: process.env.REACT_APP_CODE,
      shop_domain: shop,
      notification_id: id
    },
    url: `${commonApi}ak/get-notification`
  };
  return yield callApiServiceCommon(payload);
}
